// extracted by mini-css-extract-plugin
export default {"PostList":"PostList_PostList__k2c4b","name":"PostList_name__tK5By","arrow":"PostList_arrow__IBs-8","author":"PostList_author__JwjiE","type":"PostList_type__uwB4E"};